import { useState } from "react";
import { Flag, Download, Copy } from "lucide-react";
import { toast } from "sonner";

const SITE_URL = "https://laconsoledesartistes.fr";

const BANNERS = [
  { key: "banniere", file: "/pub/banniere-site-1920x640.png", label: "Bannière large", dims: "1920 × 640", hint: "Site web · newsletter · blog" },
  { key: "couverture", file: "/pub/couverture-facebook-1640x624.png", label: "Couverture Facebook", dims: "1640 × 624", hint: "Haut de votre page Facebook" },
  { key: "header_x", file: "/pub/banniere-x-linkedin-1500x500.png", label: "Bannière X / LinkedIn", dims: "1500 × 500", hint: "En-tête de profil" },
];

const SITE_CAPTION = `La Console des Artistes — la musique qui porte vos images.\nMusiques libres de droit pour pubs, films et créateurs. Les musiciens vendent leurs créations, les créateurs les licencient en un clic.\n${SITE_URL}`;

export const SiteBanners = () => {
  const copy = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copié !`);
  };

  return (
    <section className="border border-white/[0.08] bg-surface p-8" data-testid="site-banners-section">
      <h2 className="flex items-center gap-3 font-display text-2xl font-medium">
        <Flag className="h-5 w-5 text-amber-500" /> Bannières du site
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-zinc-400">
        Pour communiquer sur La Console des Artistes : bannières prêtes à l'emploi, lien du site
        (la carte avec la grande image s'affiche automatiquement sur Facebook, X et LinkedIn) et
        texte de présentation prêt à copier.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {BANNERS.map((b) => (
          <div key={b.key} className="border border-white/[0.06] p-4" data-testid={`site-banner-${b.key}`}>
            <img src={b.file} alt={b.label} data-testid={`site-banner-preview-${b.key}`}
                 className="w-full border border-white/10 object-cover" loading="lazy" />
            <p className="mt-3 text-sm font-medium text-zinc-100">{b.label}</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{b.dims} — {b.hint}</p>
            <a
              href={b.file} download
              data-testid={`site-banner-download-${b.key}`}
              className="mt-3 flex w-full items-center justify-center gap-2 border border-amber-500/50 py-2.5 text-[11px] font-bold uppercase tracking-[0.2em] text-amber-400 transition-colors hover:bg-amber-500 hover:text-black"
            >
              <Download className="h-4 w-4" /> Télécharger
            </a>
          </div>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="border border-white/[0.06] p-4">
          <p className="text-[10px] uppercase tracking-[0.25em] text-amber-400">Lien du site à partager</p>
          <div className="mt-3 flex items-center gap-2">
            <input
              readOnly value={SITE_URL} onFocus={(e) => e.target.select()}
              data-testid="site-link-input"
              className="min-w-0 flex-1 border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-xs text-amber-200/90 outline-none"
            />
            <button
              onClick={() => copy(SITE_URL, "Lien du site")}
              data-testid="site-link-copy"
              className="shrink-0 border border-amber-500/60 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.15em] text-amber-400 transition-colors hover:bg-amber-500 hover:text-black"
            >
              Copier
            </button>
          </div>
          <p className="mt-2 text-[10px] leading-relaxed text-zinc-600">
            Collé sur Facebook, X ou LinkedIn, ce lien affiche automatiquement la grande carte du site.
          </p>
        </div>
        <div className="border border-white/[0.06] p-4">
          <div className="flex items-center justify-between">
            <p className="text-[10px] uppercase tracking-[0.25em] text-amber-400">Texte de présentation</p>
            <button
              onClick={() => copy(SITE_CAPTION, "Texte")}
              data-testid="site-caption-copy"
              className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-zinc-400 transition-colors hover:text-amber-400"
            >
              <Copy className="h-3.5 w-3.5" /> Copier
            </button>
          </div>
          <p className="mt-2 whitespace-pre-line text-xs leading-relaxed text-zinc-400" data-testid="site-caption">{SITE_CAPTION}</p>
        </div>
      </div>
    </section>
  );
};
